import React, { useEffect } from 'react'

import StudentDrawerContent from 'modules/Roles/Partials/ViewCollegeDetails/Partials/ViewStudentDrawer/Partials/StudentDrawerContent'

import {
  BoldTitle,
  StyledDrawer,
} from 'modules/Roles/Partials/ViewCollegeDetails/Partials/ViewStudentDrawer/style'
import { getPromotion } from 'modules/Roles/actions'
import { useDispatch } from 'react-redux'

const ViewStudentDrawer = ({
  viewDrawer,
  setViewDrawer,
  singleStudentData,
  promotionData,
  roleId
}) => {
  const dispatch = new useDispatch()

  // useEffect(() => {
  //   dispatch(getPromotion(singleStudentData?.id))
  // }, [singleStudentData?.id])

  const content = () => {
    return (
      <StudentDrawerContent
        singleStudentData={singleStudentData}
        promotionData={promotionData}
        flag={true}
        roleId={roleId}
      />
    )
  }

  return (
    <StyledDrawer
      width="58%"
      height="98%"
      title={<BoldTitle>View</BoldTitle>}
      placement="right"
      onClose={() => setViewDrawer(false)}
      closable={true}
      visible={viewDrawer}
      content={content()}
      padding="15px 30px"
      destroyOnClose={true}
    />
  )
}

export default ViewStudentDrawer
